import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';

export default function NotFound() {
	const { t } = useTranslation();

	return (
		<div className="flex items-center flex-col gap-5 justify-center h-[calc(100svh_-_200px)]">
			<h1 className="text-6xl text-center max-md:text-3xl uppercase text-neutral-500">
				{t('global.not_found.title')}
			</h1>
			<p className="text-lg max-md:text-md max-w-[400px] text-center font-light text-neutral-500">
				{t('global.not_found.description')}
			</p>

			<Link
				to="/"
				className="bg-[var(--primary)] hover:brightness-95 goldman p-2 px-4 cursor-pointer text-white rounded-xl"
			>
				{t('global.not_found.button_text')}
			</Link>
		</div>
	);
}
